<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="30%"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="视频名称"
          prop="liveVideoName"
        >
          <el-input v-model="createForm.liveVideoName" />
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

export default {
  name: 'CourseCategory',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      title: '修改课程章节',
      cancelText: '取消',
      disabledBtn: false,
      createForm: {
        id: '',
        liveVideoName: '',
      },
      creatRules: {
        liveVideoName: [
          { required: true, message: '请输入视频名称', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    item(val) {
      if (val) {
        const {
          name,
          id,
        } = val;
        this.createForm = {
          liveVideoName: name,
          id,
        };
      }
    },
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.createForm.clearValidate();
          this.createForm.id = this.item.id;
          this.createForm.liveVideoName = this.item.name;
        });
      }
    },
  },
  methods: {
    // 关闭弹窗
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.live.updateLiveRecordVideoName(this.createForm);
          if (!data) return;
          if (this.createForm.id) {
            this.$message.success('修改视频名称成功');
          }
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
  },
};
</script>
